module.exports = __webpack_public_path__ + "img/output-onlinegiftools (33).898957af.gif";